<template>
  <section class="section section-alt" id="news">
    <div class="section-inner">
      <div class="section-header reveal">
        <div class="section-number">02 / NEWS</div>
        <h2 class="section-title">展会资讯</h2>
        <p class="section-desc">掌握展会最新动态，第一时间获取重要资讯</p>
      </div>
      <div class="news-grid" v-if="!loading && newsList.length">
        <a
          v-for="item in newsList"
          :key="item.id"
          class="news-card reveal"
          :href="'#/news/' + item.id"
        >
          <div class="news-card-date">
            <div class="news-card-month">{{ item.month }}</div>
            <div class="news-card-day">{{ item.day }}</div>
          </div>
          <div class="news-card-body">
            <h4 class="news-card-title">{{ item.title }}</h4>
            <p class="news-card-desc">{{ item.desc }}</p>
            <span class="news-card-more">查看详情 →</span>
          </div>
        </a>
      </div>
      <div class="news-empty reveal" v-else-if="!loading">
        <p>暂无资讯内容</p>
      </div>
      <div class="news-more-wrap reveal" v-if="total > newsList.length">
        <a href="#/news" class="news-more-link">查看全部资讯 →</a>
      </div>
    </div>
  </section>
</template>

<script>
import { getArticleList } from "../api";

export default {
  name: 'NewsSection',
  data() {
    return {
      loading: true,
      newsList: [],
      total: 0,
    };
  },
  async mounted() {
    const { list, total } = await getArticleList(0, 20);
    this.newsList = list.slice(0, 4);
    this.total = total;
    this.loading = false;
    this.$nextTick(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      this.$el.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    });
  }
};
</script>

<style scoped>
  .section {
    padding: 120px 32px;
    position: relative;
    background: #FBF7F1;
  }

  .section-inner {
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-header {
    text-align: center;
    margin-bottom: 72px;
  }

  .section-number {
    display: inline-block;
    font-family: var(--font-serif);
    font-size: 14px;
    color: var(--color-primary);
    font-weight: 700;
    letter-spacing: 3px;
    margin-bottom: 16px;
    position: relative;
    padding: 0 40px;
  }

  .section-number::before,
  .section-number::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 30px;
    height: 1px;
    background: var(--color-primary-light);
  }

  .section-number::before { left: 0; }
  .section-number::after { right: 0; }

  .section-title {
    font-family: var(--font-serif);
    font-weight: 900;
    font-size: clamp(32px, 4vw, 48px);
    color: var(--color-text);
    margin-bottom: 16px;
    line-height: 1.2;
  }

  .section-desc {
    font-size: 16px;
    color: var(--color-text-light);
    max-width: 640px;
    margin: 0 auto;
    line-height: 1.8;
  }

  .reveal {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.8s ease, transform 0.8s ease;
  }

  .reveal.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .news-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }

  .news-card {
    display: flex;
    gap: 24px;
    background: var(--color-white);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    padding: 28px 32px;
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .news-card::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, var(--color-primary), var(--color-accent));
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 0.4s ease;
  }

  .news-card:hover {
    border-color: var(--color-primary-light);
    transform: translateY(-4px);
    box-shadow: 0 16px 40px rgba(237, 123, 26, 0.12);
  }

  .news-card:hover::before {
    transform: scaleY(1);
  }

  .news-card-date {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, var(--color-primary), var(--color-accent));
    border-radius: var(--radius-md);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: var(--font-serif);
  }

  .news-card-month {
    font-size: 13px;
    letter-spacing: 2px;
    margin-bottom: 4px;
    opacity: 0.9;
  }

  .news-card-day {
    font-size: 28px;
    font-weight: 900;
    line-height: 1;
  }

  .news-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .news-card-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--color-text);
    margin: 0;
    line-height: 1.5;
    transition: color 0.2s ease;
  }

  .news-card:hover .news-card-title {
    color: var(--color-primary);
  }

  .news-card-desc {
    font-size: 14px;
    color: var(--color-text-light);
    line-height: 1.75;
    margin: 0;
    flex: 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .news-card-more {
    font-size: 13px;
    color: var(--color-primary);
    font-weight: 600;
    letter-spacing: 1px;
  }

  .news-empty {
    text-align: center;
    padding: 56px 24px;
    color: var(--color-text-light);
    background: #fff;
    border: 1px dashed var(--color-border);
    border-radius: var(--radius-lg);
    font-size: 15px;
  }

  .news-more-wrap {
    text-align: center;
    margin-top: 48px;
  }

  .news-more-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 36px;
    border-radius: 999px;
    background: #fff;
    border: 1px solid var(--color-primary-light);
    color: var(--color-primary);
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1px;
    transition: all 0.3s ease;
  }

  .news-more-link:hover {
    background: linear-gradient(135deg, var(--color-primary), var(--color-accent));
    color: #fff;
    border-color: transparent;
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(237, 123, 26, 0.22);
  }

  @media (max-width: 968px) {
    .news-grid { grid-template-columns: 1fr; }
    .news-card { padding: 24px; }
    .news-card-date { width: 64px; height: 64px; }
    .news-card-day { font-size: 22px; }
  }

  @media (max-width: 640px) {
    .section { padding: 80px 24px; }
    .news-card { flex-direction: column; gap: 16px; }
    .news-card-date { width: 100%; height: auto; padding: 12px 0; }
  }
</style>
